var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    height: 600,
    width: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76,13a3.19,3.19,0,0,0,4-.44l.45-.44a1.08,1.08,0,0,0,0-1.51L11.3,8.72a1.07,1.07,0,0,0-1.5,0h0a1.08,1.08,0,0,1-1.51,0l-3-3a1.06,1.06,0,0,1,0-1.51h0a1.07,1.07,0,0,0,0-1.5L3.39.81a1.08,1.08,0,0,0-1.51,0l-.44.45a3.19,3.19,0,0,0-.44,4A28.94,28.94,0,0,0,8.76,13Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTelephone);
export default __webpack_public_path__ + "static/media/streamline-icon-telephone.d22e5b77.svg";
export { ForwardRef as ReactComponent };